package com.cybersoftsolution.cybersoftsolutionweb.components.bars

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyFaIcon
import com.cybersoftsolution.cybersoftsolutionweb.components.indicators.LoadingIndicator
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.selectedColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.InputTypeHTML
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.MyTextField
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Rotate_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SearchTextNoStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SimpleWithAnimationStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.XIconStyle2
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.searchTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignContent
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onKeyDown
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import org.jetbrains.compose.web.css.AlignContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement

@Composable
fun SubscribeBarCollapsable(
    id: String,
    placeHolder: String = "",
    maxWidth: Int = 300,
    modifier: Modifier = Modifier,
    style: CssStyle<GeneralKind>,

    isSubscribe: Boolean = false,
    onSubscribe: (text: String) -> Unit,
    onUnSubscribe: (text: String) -> Unit,
    email :String ="",
    onEmailChange: (String) -> Unit,
    isSubscribing: Boolean = false,
){

    var focused by remember { mutableStateOf(false) }
    var expanded by remember { mutableStateOf(false) }




    LaunchedEffect(expanded){
        if (expanded){
            (document.getElementById(id) as HTMLInputElement).focus()
        }
    }

    LaunchedEffect(isSubscribe){
        if (isSubscribe) {
            expanded = false
        }
    }



    Box(
        modifier = SimpleWithAnimationStyle.toModifier()
            .then(modifier)
            .id("${id}_BoxContainer")
            .thenIf(
                condition = expanded,
                other = Modifier
                    .minWidth(maxWidth.px)
                    .maxWidth(maxWidth.px)
                    .width(maxWidth.px)
            )


    ) {


        if (!expanded) {
            Row(
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Scale_Selected_ItemStyle.toModifier()
                    .fillMaxWidth()
                    .height(45.px)
//                    .padding(left = 16.px, right = 0.px)
                    .backgroundColor(Theme.Transparent.rgb)
                    .thenIf(
                        condition = focused,
                        other = Modifier.border(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = selectedColor
                        )

                    )
                    .cursor(Cursor.Pointer)
                    .onClick {
                        expanded = !expanded
                    }

                ,
            ) {
                MyFaIcon(
                    modifier = Modifier
                        .fillMaxHeight(),
//                        .padding(top = 4.px)
//                        .margin(right = 16.px),
                    style = Scale_Rotate_Selected_ItemStyle,
                    id = "subscribeBarToggleIconId",
                    faIconsClassName = Resources.FaIconsClassName.Subscribe_ICO ,
                    size = 32,
                    onClick = {
                        expanded = !expanded
                    }
                )
                SpanText(
                    modifier = Modifier
//                .cursor(Cursor.Pointer)
                        .minHeight(34.px)
                        .textAlign(TextAlign.Center)
                        .fontSize(16.px)
                        .fontStyle(FontStyle.Oblique)
                        .color(if (!isSubscribe) Theme.Withe.rgb else Theme.HalfWithe.rgb)
                        .margin(left = 10.px),
                    text = if (isSubscribe) email else "Si, quiero recibir noticias"
                )
            }



        } else {
            Column {
                Row(
                    horizontalArrangement = Arrangement.Start,
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = style.toModifier()
                        .fillMaxWidth()
//                        .visibility(if (isSubscribe) Visibility.Hidden else Visibility.Visible)
                        .height(45.px)
                        .padding(left = 16.px, right = 0.px)
                        .backgroundColor(Theme.Transparent.rgb)
                        .borderRadius(10.px)
                        .thenIf(
                            condition = focused,
                            other = Modifier.border(
                                width = 2.px,
                                style = LineStyle.Solid,
                                color = selectedColor
                            )

                        )
                        .then(modifier)

                    ,
                ) {

                    if (isSubscribing) {
                        LoadingIndicator(
                            size = 2,
                            modifier = Modifier
                                .color(Theme.Primary.rgb)
                                .padding(left = 5.px)
                                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
                                .width(10.px)
                                .height(10.px)
                                .margin(right = 20.px)
                        )
                    } else {
                        MyFaIcon(
                            faIconsClassName = Resources.FaIconsClassName.Subscribe_ICO,
                            size = 24,
                            id = "subscribeEmailIconId",
                            modifier = Modifier
                                .color(if (focused) selectedColor else unselectedColor)
                                .margin(right = 14.px)
                                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms)),

                            )
                    }





                    MyTextField(
                        usePlaceholderColorStyle = true,
                        modifier = Modifier
                            .background(Colors.Transparent)
                            .fillMaxHeight()
                            .fillMaxWidth( 90.percent)
                            .padding(left = 5.px , right = 10.px)
                            .margin(topBottom = 2.px)
                            .fontSize(14.px)
                            .color(selectedColor)
                            .onFocusIn {
                                focused = true
                                console.info("focused = $focused")
                            }
                            .onFocusOut {
                                focused = false
                                console.info("focused = $focused")

                            }
                            .onKeyDown {
                                if (it.key == "Enter") {
                                    (document.getElementById(id) as HTMLInputElement).blur()
                                    onSubscribe(email)
                                }

                            }


                        ,
                        enabled = !isSubscribe,
                        text = email,
                        style = SearchTextNoStyle,
                        inputTypeHTML = InputTypeHTML.Text,
                        id = id,
                        placeholder = placeHolder,
                        onChange = {
                            onEmailChange(it)
                        }
                    )



                    FaX(
                        size = IconSize.SM,
                        modifier = XIconStyle2.toModifier()
                            .margin( leftRight = 10.px)
                            .fillMaxWidth(10.percent)
                            .onClick {
                                expanded = false
                            }
                            .cursor(Cursor.Pointer)
                            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))

                    )


                }


                if (!isSubscribe) {
                    MyButton(
                        borderRadius = 10.px,
                        width = maxWidth.px,
                        buttonType = MyButtonType.Primary,
                        modifier = Modifier
                            .height(42.px)
                            .margin(topBottom = 10.px)
                            .padding(leftRight = 10.px)
                        ,
                        id = "subscribeButtonId",
                        text = "Suscribirme",
                        fontSize = 15,
                        enabled = email.isNotEmpty(),
                        onClick = {
                            onSubscribe(email)
                        }
                    )
                } else {
                    MyButton(
                        borderRadius = 10.px,
                        width = maxWidth.px,
                        buttonType = MyButtonType.Delete,
                        modifier = Modifier
                            .height(42.px)
                            .margin(topBottom = 10.px)
                            .padding(leftRight = 10.px)
                        ,
                        id = "desSubscribeButtonId",
                        text = "Suspender mi suscripción",
                        fontSize = 15,
                        enabled = true,
                        onClick = {
                            onUnSubscribe(email)
                        }
                    )

                }




            }

        }





    }






}